// import Swiper from 'swiper';
// import 'swiper/css/bundle';
require('slick-carousel');

if($('.slider-logos').length) {

    if($(window).width() > 991) {
        $('.slider-logos').each(function () {

            let desktopSlideCount = 6,
                tabletSlideCount = 4,
                mobileSlideCount = 2;

            // inline auto scrolling list of logos
            $(this).slick({
                slidesToShow: 6,
                // slidesToScroll: 6,
                autoplay: true,
                // arrows: false,
                // autoplaySpeed: 3000,
                autoplaySpeed: 0,
                speed: 3000,
                cssEase: 'linear',
                arrows: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                responsive: [
                    { breakpoint: 575, settings: { slidesToShow: mobileSlideCount }},
                    { breakpoint: 992, settings: { slidesToShow: tabletSlideCount }},
                    { breakpoint: 1200, settings: { slidesToShow: desktopSlideCount }}
                ]
            });

        });
    }

    if($(window).width() < 992) {

        $('.slider-logos-mobile').each(function () {

            $(this).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                arrows: false,
                autoplaySpeed: 3000,
            });

        });

    }

}

// if($('.slider-logos').length) {
//     $('.slider-logos').each(function () {
//
//         let desktopSlideCount = 6,
//             tabletSlideCount = 5,
//             mobileSlideCount = 3;
//
//         // if($(this).hasClass("slider-large")) {
//         //     desktopSlideCount = 5;
//         //     tabletSlideCount = 3;
//         //     mobileSlideCount = 2;
//         // }
//
//         // inline auto scrolling list of logos
//         var swiper = new Swiper(".slider-logos", {
//             spaceBetween: 0,
//             // centeredSlides: true,
//             speed: 9000,
//             loop: true,
//             autoplay: {
//                 delay: 1,
//             },
//             slidesPerView: 2,
//             allowTouchMove: false,
//             disableOnInteraction: true,
//             breakpoints: {
//                 575: {
//                     slidesPerView: mobileSlideCount,
//                 },
//                 992: {
//                     slidesPerView: tabletSlideCount,
//                 },
//                 1200: {
//                     slidesPerView: desktopSlideCount,
//                 }
//             },
//             on: {
//                 afterInit: function (swiper) {
//                     console.log('init');
//                     console.log(swiper);
//                     $(swiper.el).removeClass('slider-loading');
//                     // console.log($(this).removeClass('slider-loading'));
//                 },
//             },
//         });
//
//     });
// }
